//ACHIEVEMENT
export const SET_ACHIEVEMENTS = 'SET_ACHIEVEMENTS'
export const SET_ACHIEVEMENTS_LOADED = 'SET_ACHIEVEMENTS_LOADED'
//GENERAL
export const SET_BOOKMARKS = 'SET_BOOKMARKS'
export const SET_CAPGEMINI_COMPANY = 'SET_CAPGEMINI_COMPANY'
export const SET_CAPGEMINI_COMPANY_SLUG = 'SET_CAPGEMINI_COMPANY_SLUG'
export const SET_CAPGEMINI_COMPANY_LOADED = 'SET_CAPGEMINI_COMPANY_LOADED'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_HIGHLIGHTED_CONTENT_ORDER = 'SET_HIGHLIGHTED_CONTENT_ORDER'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const SET_SECTIONS = 'SET_SECTIONS'
export const SET_SETTINGS_COMPANY = 'SET_SETTINGS_COMPANY'
export const SET_SETTINGS_GLOBAL = 'SET_SETTINGS_GLOBAL'
export const SET_SETTINGS_TYPES = 'SET_SETTINGS_TYPES'
export const SET_UI_ENGAGEMENTS = 'SET_UI_ENGAGEMENTS'
export const SET_USER = 'SET_USER'
export const SET_USER_CONTENT_FIELD_OPTIONS = 'SET_USER_CONTENT_FIELD_OPTIONS'
export const SET_PUBLIC_USER = 'SET_PUBLIC_USER'
export const SET_USER_COMPANY = 'SET_USER_COMPANY'
export const SET_USER_COMPANIES = 'SET_USER_COMPANIES'
export const SET_USER_INFO_LOADED = 'SET_USER_INFO_LOADED'
export const SET_TOKEN = 'SET_TOKEN'
//AGENDA
export const SET_AGENDA = 'SET_AGENDA'
export const SET_AGENDA_LOADED = 'SET_AGENDA_LOADED'
export const SET_AGENDA_EVENT = 'SET_AGENDA_EVENT'
export const SET_AGENDA_EVENT_LOADED = 'SET_AGENDA_EVENT_LOADED'
export const SET_AGENDA_ADDITIONAL_DATA = 'SET_AGENDA_ADDITIONAL_DATA'
export const SET_AGENDA_ADDITIONAL_DATA_LOADED = 'SET_AGENDA_ADDITIONAL_DATA_LOADED'
//CLIENT
export const CLEAN_CLIENT = 'CLEAN_CLIENT'
export const CLEAN_CLIENTS = 'CLEAN_CLIENTS'
export const SET_CLIENT = 'SET_CLIENT'
export const SET_CLIENT_LOADED = 'SET_CLIENT_LOADED'
export const SET_CLIENT_META = 'SET_CLIENT_META'
export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_CLIENTS_LOADED = 'SET_CLIENTS_LOADED'
export const SET_CLIENTS_META = 'SET_CLIENTS_META'
export const SET_WHOLE_CLIENTS = 'SET_WHOLE_CLIENTS'
//COMMENTS
export const SET_COMMENTS = 'SET_COMMENTS'
export const SET_COMMENTS_LOADED = 'SET_COMMENTS_LOADED'
//COMPANY
export const SET_COMPANY = 'SET_COMPANY'
export const SET_COMPANIES = 'SET_COMPANIES'
export const SET_PUBLIC_COMAPNIES_LOADED = 'SET_PUBLIC_COMAPNIES_LOADED'
export const SET_PUBLIC_COMAPNIES = 'SET_PUBLIC_COMAPNIES'
export const SET_PUBLIC_COMAPNY_LOADED = 'SET_PUBLIC_COMAPNY_LOADED'
export const SET_PUBLIC_COMAPNY = 'SET_PUBLIC_COMAPNY'
//COMPANY FILES
export const SET_FILES = 'SET_FILES'
export const SET_FILES_LOADED = 'SET_FILES_LOADED'
//CONTENT FIELDS
export const SET_CONTENT_FIELDS = 'SET_CONTENT_FIELDS'
export const SET_CONTENT_FIELD_OPTIONS = 'SET_CONTENT_FIELD_OPTIONS'
//CONTENT SECTION
export const SET_CONTENT_SECTION = 'SET_CONTENT_SECTION'
export const SET_CONTENT_SECTION_LOADED = 'SET_CONTENT_SECTION_LOADED'
export const SET_WHOLE_CONTENT_SECTION = 'SET_WHOLE_CONTENT_SECTION'
//ENGAGEMENTS
export const SET_ENGAGEMENT = 'SET_ENGAGEMENT'
export const SET_ENGAGEMENTS = 'SET_ENGAGEMENTS'
export const SET_ENGAGEMENTS_LOADED = 'SET_ENGAGEMENTS_LOADED'
export const SET_ENGAGEMENT_KEY_FACTS = 'SET_ENGAGEMENT_KEY_FACTS'
export const SET_ENGAGEMENT_PROJECTS = 'SET_ENGAGEMENT_PROJECTS'
export const SET_ENGAGEMENTS_PROJECTS_LOADED = 'SET_ENGAGEMENTS_PROJECTS_LOADED'
//HIGHLIGHT CONTENT
export const SET_HIGHLIGHT_CONTENT = 'SET_HIGHLIGHT_CONTENT'
export const SET_HIGHLIGHT_CONTENT_LOADED = 'SET_HIGHLIGHT_CONTENT_LOADED'
//HIRE REQUEST
export const SET_HIRE_REQUEST = 'SET_HIRE_REQUEST'
export const SET_HIRE_REQUEST_LOADED = 'SET_HIRE_REQUEST_LOADED'
export const SET_HIRE_REQUESTS = 'SET_HIRE_REQUESTS'
export const SET_HIRE_REQUESTS_LOADED = 'SET_HIRE_REQUESTS_LOADED'
//IDEAS
export const CLEAN_IDEAS = 'CLEAN_IDEAS'
export const SET_FEATURED_IDEAS = 'SET_FEATURED_IDEAS'
export const SET_IDEA = 'SET_IDEA'
export const SET_IDEA_LOADED = 'SET_IDEA_LOADED'
export const SET_IDEAS = 'SET_IDEAS'
export const SET_IDEAS_COUNT = 'SET_IDEAS_COUNT'
export const SET_IDEAS_LOADED = 'SET_IDEAS_LOADED'
export const SET_IDEAS_META = 'SET_IDEAS_META'
//IMAGES
export const SET_IMAGES = 'SET_IMAGES'
export const SET_IMAGES_CATEGORIES = 'SET_IMAGES_CATEGORIES'
export const SET_IMAGES_CATEGORIES_LOADED = 'SET_IMAGES_CATEGORIES_LOADED'
export const SET_IMAGES_LOADED = 'SET_IMAGES_LOADED'
//INITIATIVES
export const SET_INITIATIVES = 'SET_INITIATIVES'
export const SET_INITIATIVES_LOADED = 'SET_INITIATIVES_LOADED'
//NEWS
export const CLEAN_NEWS = 'CLEAN_NEWS'
export const SET_NEWS = 'SET_NEWS'
export const SET_NEWS_CATEGORIES = 'SET_NEWS_CATEGORIES'
export const SET_CATEGORY_NEWS_LOADED = 'SET_CATEGORY_NEWS_LOADED'
export const SET_NEWS_COUNT = 'SET_NEWS_COUNT'
export const SET_NEWS_LOADED = 'SET_NEWS_LOADED'
export const SET_NEWS_META = 'SET_NEWS_META'
export const SET_SINGLE_NEWS = 'SET_SINGLE_NEWS'
export const SET_SINGLE_NEWS_LOADED = 'SET_SINGLE_NEWS_LOADED'
//PROJECTS
export const SET_PROJECT = 'SET_PROJECT'
export const SET_PROJECT_LOADED = 'SET_PROJECT_LOADED'
export const SET_PROJECTS = 'SET_PROJECTS'
export const SET_PROJECTS_LOADED = 'SET_PROJECTS_LOADED'
//QUIZZES
export const SET_LEADERBOARD = 'SET_LEADERBOARD'
export const SET_LEADERBOARD_LOADED = 'SET_LEADERBOARD_LOADED'
export const SET_LEADERBOARDS = 'SET_LEADERBOARDS'
export const SET_LEADERBOARDS_LOADED = 'SET_LEADERBOARDS_LOADED'
export const SET_QUIZ_ANSWERS = 'SET_QUIZ_ANSWERS'
export const SET_QUIZZES = 'SET_QUIZZES'
export const SET_QUIZZES_LOADED = 'SET_QUIZZES_LOADED'
export const SET_QUIZ = 'SET_QUIZ'
export const SET_QUIZ_LOADED = 'SET_QUIZ_LOADED'
//SOLUTION
export const SET_SOLUTION = 'SET_SOLUTION'
export const SET_SOLUTION_LOADED = 'SET_SOLUTION_LOADED'
export const SET_SOLUTIONS = 'SET_SOLUTIONS'
export const SET_SOLUTIONS_LOADED = 'SET_SOLUTIONS_LOADED'
//TEAM MEMBERS
export const SET_TEAM_MEMBERS = 'SET_TEAM_MEMBERS'
export const SET_TEAM_MEMBERS_LOADED = 'SET_TEAM_MEMBERS_LOADED'
export const SET_TEAM_MEMBER = 'SET_TEAM_MEMBER'
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION'